<template lang="pug">
  div(id="app")
    Navbar
    router-view
    


</template>

<script>
import Navbar from './components/Navbar.vue';
import ImageRow from './components/ImageRow.vue';

export default {
  title: 'Shi Guorui',
  components: {
    Navbar,
    ImageRow
  }  
}
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
